import feathersApp from "../feathers";

let teamsLoaded = false;
let inflight = null;

export const loadTeams = () => async (dispatch) => {
  if (teamsLoaded) {
    return;
  }
  if (!inflight) {
    inflight = feathersApp
      .service("teams")
      .find()
      .then((res) => {
        const list = Array.isArray(res) ? res : res?.data || [];
        if (!list.length) {
          return;
        }
        const payload = list.reduce((acc, row) => {
          const { code, name } = row || {};
          if (code && name != null && name !== "") {
            acc[String(code).toLowerCase()] = name;
          }
          return acc;
        }, {});
        if (Object.keys(payload).length) {
          dispatch({ type: "TEAMS_MERGE", payload });
          teamsLoaded = true;
        }
      })
      .catch((err) => {
        console.warn("loadTeams:", err?.message || err);
      })
      .finally(() => {
        inflight = null;
      });
  }
  await inflight;
};
